import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts';

export type ActiveUsersPoint = { date: string; activeUsers: number };

const ACTIVE_USERS_COLOR = '#2a78d6';

const formatDateTick = (value: string) => {
  const date = new Date(`${value}T00:00:00`);
  if (isNaN(date.getTime())) return value;
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

export const ActiveUsersChart = ({
  data,
  isLoading = false,
}: {
  data: ActiveUsersPoint[];
  isLoading?: boolean;
}) => {
  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Unique Active Users per Day</h3>

      {isLoading ? (
        <div className="h-72 flex items-center justify-center text-gray-500 text-sm">Loading…</div>
      ) : data.length === 0 ? (
        <div className="h-72 flex items-center justify-center text-gray-500 text-sm">No data for the selected range</div>
      ) : (
        <ResponsiveContainer width="100%" height={300}>
          <LineChart data={data} margin={{ top: 4, right: 8, left: -8, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#e1e0d9" />
            <XAxis dataKey="date" tickFormatter={formatDateTick} stroke="#898781" tick={{ fontSize: 12 }} />
            <YAxis allowDecimals={false} stroke="#898781" tick={{ fontSize: 12 }} />
            <Tooltip labelFormatter={(value) => formatDateTick(String(value))} />
            <Line
              type="monotone"
              dataKey="activeUsers"
              name="Active Users"
              stroke={ACTIVE_USERS_COLOR}
              strokeWidth={2}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      )}
    </div>
  );
};
